module.exports = __webpack_public_path__ + "static/media/solerpalau.cbce501a.jpg";